import type React from 'react';
import AccountIcon from '../../../../../ui/new-assets/account-white.svg';
import LockIcon from '../../../../../ui/new-assets/lock.svg';
import RoyaltyProgramIcon from '../../../../../ui/new-assets/royalty-program.svg';
import VehicleIcon from '../../../../../ui/new-assets/vehicle.svg';
import type { ITranslationFunction } from '../../../../shared/i18n/translate';
import { Color } from '../../../../shared/styles/Color';

interface IAccountUrls {
	royaltyProgramUrl: string;
	accountDetailsUrl: string;
	changePasswordUrl: string;
	myVehiclesUrl: string;
}
export const getAccountShortcuts = (
	t: ITranslationFunction,
	urls: IAccountUrls,
) => [
	{
		title: t('loyalty_royalty_program_label'),
		href: urls.royaltyProgramUrl,
		color: Color.AccentDefault,
		icon: <RoyaltyProgramIcon />,
		isNew: true,
	},
	{
		title: t('account_details_label'),
		href: urls.accountDetailsUrl,
		color: Color.PrimaryDark,
		icon: <AccountIcon />,
	},
	{
		title: t('account_my_vehicles_label'),
		href: urls.myVehiclesUrl,
		color: Color.SecondaryDefault,
		icon: <VehicleIcon />,
		isNew: true,
	},
	{
		title: t('account_change_password_label'),
		href: urls.changePasswordUrl,
		color: Color.AccentDefault,
		icon: <LockIcon />,
	},
];
